import { useSelector } from 'react-redux';
import { RootState } from 'reducers/rootReducer';
const useIsAnonymous = () => {
    return useSelector((state: RootState) => {
        return state.viewConfig && state.viewConfig.user && state.viewConfig.user.login === 'anonymousUser';
    });
};
export default useIsAnonymous;
